(() => {
  const initSale = (root) => {
    if (!root || root.dataset.sppSaleReady === 'true') return;
    root.dataset.sppSaleReady = 'true';

    const filters = Array.from(root.querySelectorAll('[data-spp-sale-filter]'));
    const cards = Array.from(root.querySelectorAll('[data-spp-sale-card]'));
    const count = root.querySelector('[data-spp-sale-visible-count]');
    const empty = root.querySelector('[data-spp-sale-no-filter]');

    filters.forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.dataset.sppSaleFilter || 'all';
        const threshold = filter === 'all' ? 0 : Number(filter);
        let visible = 0;

        filters.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        cards.forEach((card) => {
          const discount = Number(card.dataset.discount || 0);
          const show = filter === 'all' || discount >= threshold;
          card.hidden = !show;
          if (show) visible += 1;
        });

        if (count) count.textContent = `${visible} ${visible === 1 ? 'deal' : 'deals'}`;
        if (empty) empty.hidden = visible !== 0;
      });
    });

    root.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-spp-sale-add]');
      if (!button || !root.contains(button) || button.disabled) return;

      const variantId = button.dataset.variantId;
      if (!variantId) return;

      const defaultLabel = button.dataset.defaultLabel || button.textContent.trim() || 'Add to Cart';
      button.disabled = true;
      button.textContent = 'Adding...';

      try {
        const rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
        const response = await fetch(`${rootPath}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: 1 }],
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname
          })
        });

        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || 'Unable to add item');

        button.textContent = 'Added';

        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(data);
          if (typeof drawer.open === 'function') window.setTimeout(() => drawer.open(), 40);
        } else {
          const bubble = document.getElementById('cart-icon-bubble');
          const bubbleHtml = data.sections && data.sections['cart-icon-bubble'];
          if (bubble && bubbleHtml) {
            const wrapper = document.createElement('div');
            wrapper.innerHTML = bubbleHtml.trim();
            const replacement = wrapper.querySelector('#cart-icon-bubble');
            if (replacement) bubble.replaceWith(replacement);
          }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
        }

        window.setTimeout(() => {
          button.textContent = defaultLabel;
          button.disabled = false;
        }, 1300);
      } catch (error) {
        console.error('[SPP Sale] Add to cart failed:', error);
        button.textContent = 'Try Again';
        button.disabled = false;
        window.setTimeout(() => { button.textContent = defaultLabel; }, 1800);
      }
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-spp-sale-v2]').forEach(initSale);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
